import {Injectable} from "@angular/core";
/**
 * WARNING: Full class is instantiated via msl-login module, this implementation is a PARTIAL stub!
 */

@Injectable()
export class Login {

    private _sessionId: string;
    private _learnerId: string;
    private _name: string;
    private _tenantId: string;

    constructor() {}

  get tenantId(): string {
    return this._tenantId;
  }

  set tenantId(value: string) {
    this._tenantId = value;
  }
  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }
  get learnerId(): string {
    return this._learnerId;
  }

  set learnerId(value: string) {
    this._learnerId = value;
  }
  get sessionId(): string {
    return this._sessionId;
  }

  set sessionId(value: string) {
    this._sessionId = value;
  }
}
